<template>
  <!--  别人发送的消息-->
  <li v-if="otherSend" class="_chat-message left">
    <img class="avatar" :src="otherAvatar" alt="" />
    <p v-if="type === 'text'" class="text">
      {{ text }}
    </p>
    <img v-else class="image" :src="imageUrl" alt="" />
  </li>
  <!--  我发送的消息-->
  <li v-else class="_chat-message right">
    <p v-if="type === 'text'" class="text">
      {{ text }}
    </p>
    <img v-else class="image" :src="imageUrl" alt="" />
    <img class="avatar" :src="avatar ? avatar : defaultAvatar" alt="" />
  </li>
</template>
<script>
import { mapState, mapActions } from "vuex";
import defaultAvatar from "@/assets/personal/default_avatar@2x.png";

export default {
  name: "ChatMessage",
  props: {
    otherSend: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true,
      default: ""
    },
    image: {
      type: String,
      required: true,
      default: ""
    },
    otherAvatar: {
      type: String,
      required: true,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      imageUrl: "",
      defaultAvatar
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapState("user", ["avatar"])
  },
  methods: {
    ...mapActions("chat", ["getResource"]),
    async fetchData() {
      if (this.type === "image") {
        const { url } = await this.getResource(this.image);
        this.imageUrl = url;
        setTimeout(() => {
          this.$emit("update-content-height");
        }, 300);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
._chat-message {
  margin: 20px 0;
  display: flex;
  align-items: flex-start;
  .avatar {
    border-radius: 50%;
    /* TODO:需要设置最小最大宽度，不然宽度会变化 */
    min-width: 40px;
    max-width: 40px;
    height: 40px;
    width: 40px;
  }
  .text {
    min-height: 41px;
    padding: 10px 13px;
    background: rgba(255, 255, 255, 1);
    font-size: 15px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
    text-align: left;
  }
  .image {
    flex: 1;
    max-width: 100%;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
}
.left {
  justify-content: flex-start;
  .avatar {
    margin-right: 12px;
  }
  .image {
    border-radius: 0 16px 16px 16px;
    text-align: left;
  }
  .text {
    border-radius: 0 16px 16px 16px;
  }
}
.right {
  justify-content: flex-end;
  .avatar {
    margin-left: 12px;
  }
  .image {
    border-radius: 16px 0 16px 16px;
  }
  .text {
    text-align: left;
    border-radius: 16px 0 16px 16px;
    background: rgba(253, 215, 0, 1);
  }
}
</style>
